import { useContext } from 'react'
import { SnackContext } from '../contexts/Snackcontexts'

export const useSnack = () => useContext(SnackContext)
